import { ACTION, STEP } from '../../@types/state'

const landStates = {
  id: 'landStates',
  initial: STEP.LOCATION,
  context: {},
  states: {
    [STEP.LOCATION]: {
      entry: ['enterOrSkipLocation'],
      on: {
        [ACTION.BACK]: STEP.IBW_INITIAL,
        [ACTION.NEXT]: STEP.AREA,
        [ACTION.GO_TO_ERROR]: STEP.ERROR,
      },
    },
    [STEP.AREA]: {
      entry: ['enterOrSkipArea'],
      on: {
        [ACTION.BACK]: STEP.LOCATION,
        [ACTION.NEXT]: STEP.LAND_DEVELOPMENT_STATUS,
      },
    },
    [STEP.LAND_DEVELOPMENT_STATUS]: {
      on: {
        [ACTION.BACK]: STEP.AREA,
        [ACTION.NEXT]: STEP.LAND_DEVELOPMENT_POTENTIAL,
      },
    },
    [STEP.LAND_DEVELOPMENT_POTENTIAL]: {
      on: {
        [ACTION.BACK]: STEP.LAND_DEVELOPMENT_STATUS,
        [ACTION.NEXT]: STEP.LAND_LAYOUT,
      },
    },
    [STEP.LAND_LAYOUT]: {
      on: {
        [ACTION.BACK]: STEP.LAND_DEVELOPMENT_POTENTIAL,
        [ACTION.NEXT]: STEP.INTENT,
      },
    },
    [STEP.INTENT]: {
      entry: ['enterOrSkipIntent'],
      on: {
        [ACTION.BACK]: STEP.LAND_LAYOUT,
        [ACTION.NEXT]: [
          {
            target: STEP.SELL_INTENT,
            cond: 'isSell',
          },
          {
            target: STEP.BUYER_LEADS_VALUE_PROPOSITION,
            cond: 'isValuePropositionStep',
          },
          {
            target: STEP.RENT_OUT_INTENT,
            cond: 'isRentOutIntent',
          },
          {
            target: STEP.TIME_HORIZON,
          },
        ],
      },
    },
    [STEP.RENT_OUT_INTENT]: {
      entry: ['enterOrSkipRentOutIntent'],
      on: {
        [ACTION.BACK]: STEP.INTENT,
        [ACTION.NEXT]: [
          { target: STEP.RENT_OUT_REINFORCEMENT, cond: 'isRentOutWithoutRealtor' },
          { target: STEP.TIME_HORIZON },
        ],
      },
    },
    [STEP.RENT_OUT_REINFORCEMENT]: {
      entry: ['enterOrSkipRentOutReinforcement'],
      on: {
        [ACTION.BACK]: STEP.RENT_OUT_INTENT,
        [ACTION.NEXT]: [{ target: STEP.TIME_HORIZON }],
      },
    },
    [STEP.BUYER_LEADS_VALUE_PROPOSITION]: {
      entry: ['enterOrSkipBuyerLeadsProposition'],
      on: {
        [ACTION.BACK]: STEP.INTENT,
        [ACTION.NEXT]: [
          { target: STEP.RADIUS, cond: 'isExtendedBuyerLeadOverview' },
          { target: STEP.EQUITY, cond: 'isExtendedBuyerLead' },
          { target: STEP.TIME_HORIZON },
        ],
      },
    },
    [STEP.RADIUS]: {
      entry: ['enterOrSkipRadius'],
      on: {
        [ACTION.BACK]: STEP.BUYER_LEADS_VALUE_PROPOSITION,
        [ACTION.NEXT]: STEP.EQUITY,
      },
    },
    [STEP.EQUITY]: {
      entry: ['enterOrSkipEquity'],
      on: {
        [ACTION.BACK]: [
          { target: STEP.RADIUS, cond: 'isExtendedBuyerLeadOverview' },
          { target: STEP.BUYER_LEADS_VALUE_PROPOSITION },
        ],
        [ACTION.NEXT]: [{ target: STEP.INCOME, cond: 'isExtendedBuyerLead' }],
      },
    },
    [STEP.INCOME]: {
      entry: ['enterOrSkipIncome'],
      on: {
        [ACTION.BACK]: STEP.EQUITY,
        [ACTION.NEXT]: [{ target: STEP.EMPLOYMENT, cond: 'isExtendedBuyerLead' }],
      },
    },
    [STEP.EMPLOYMENT]: {
      entry: ['enterOrSkipEmployment'],
      on: {
        [ACTION.BACK]: STEP.INCOME,
        [ACTION.NEXT]: [{ target: STEP.TIME_HORIZON }],
      },
    },
    [STEP.SELL_INTENT]: {
      entry: ['enterOrSkipSellIntent'],
      on: {
        [ACTION.BACK]: STEP.INTENT,
        [ACTION.NEXT]: [
          {
            target: STEP.TIME_HORIZON,
            cond: 'isSellWithRealtor',
          },
          {
            target: STEP.DEV_COM_OFFER,
            cond: 'isSellWithoutRealtor',
          },
          {
            target: STEP.TIME_HORIZON,
          },
        ],
      },
    },
    [STEP.DEV_COM_OFFER]: {
      entry: ['enterOrSkipDevComOffer'],
      on: {
        [ACTION.BACK]: STEP.SELL_INTENT,
        [ACTION.NEXT]: STEP.TIME_HORIZON,
      },
    },
    [STEP.TIME_HORIZON]: {
      entry: ['enterOrSkipTimeHorizon'],
      on: {
        [ACTION.BACK]: [
          {
            target: STEP.SELL_INTENT,
            cond: 'isSell',
          },
          { target: STEP.RENT_OUT_INTENT, cond: 'isRentOutReinforcement' },

          { target: STEP.EMPLOYMENT, cond: 'isExtendedBuyerLead' },

          {
            target: STEP.INTENT,
          },
        ],
        [ACTION.NEXT]: STEP.OWNER,
      },
    },
    [STEP.OWNER]: {
      entry: ['enterOrSkipOwner'],
      on: {
        [ACTION.BACK]: STEP.TIME_HORIZON,
        [ACTION.NEXT]: [
          {
            target: STEP.CONSULTATION,
            cond: 'isConsultationScreen',
          },
          { target: STEP.EXTENDED_BUYER_LEADS_OVERVIEW, cond: 'isExtendedBuyerLeadOverview' },
          { target: STEP.PLEASE_WAIT },
        ],
      },
    },
    [STEP.EXTENDED_BUYER_LEADS_OVERVIEW]: {
      entry: ['enterOrSkipExtendedBuyOverview'],
      on: {
        [ACTION.BACK]: STEP.OWNER,
        [ACTION.NEXT]: STEP.PLEASE_WAIT,
      },
    },
    [STEP.CONSULTATION]: {
      entry: ['enterOrSkipConsultation'],
      on: {
        [ACTION.BACK]: STEP.OWNER,
        [ACTION.NEXT]: STEP.PLEASE_WAIT,
      },
    },
    [STEP.PLEASE_WAIT]: {
      on: {
        [ACTION.NEXT]: [
          { target: STEP.RESPONSE_NON_HAPPY_PATH, cond: 'isDisableContactStep' },
          { target: STEP.CONTACT },
        ],
      },
    },
    [STEP.CONTACT]: {
      on: {
        [ACTION.NEXT]: [
          { target: STEP.RESPONSE_NON_HAPPY_PATH, cond: 'isNonHappyPathLand' },
          { target: STEP.RESPONSE_EXTENDED_BUYER_LEADS, cond: 'isExtendedBuyerLead' },
          { target: STEP.ADDRESS, cond: 'isSellWithRealtor' },
          { target: STEP.RESPONSE },
        ],
        [ACTION.GO_TO_ERROR]: STEP.ERROR,
      },
    },
    [STEP.RESPONSE_EXTENDED_BUYER_LEADS]: {},
    [STEP.RESPONSE_NON_HAPPY_PATH]: {
      on: {
        [ACTION.NEXT]: [{ target: STEP.ADDRESS }],
      },
    },
    [STEP.ADDRESS]: {
      on: {
        [ACTION.NEXT]: STEP.RESPONSE,
        [ACTION.GO_TO_ERROR]: STEP.ERROR,
      },
      exit: ['sendRichEvent', 'updateRichReportSent'],
    },
    [STEP.RESPONSE]: {},
    [STEP.ERROR]: {},
  },
}

export default landStates
